import * as React from "react";

function SvgError(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 17C0 7.611 7.611 0 17 0s17 7.611 17 17-7.611 17-17 17S0 26.389 0 17zm19.429 4.047H14.57V6.477h4.858v14.57zm-4.858 6.477h4.857v-4.857h-4.857v4.857z"
        fill="#8C2228"
      />
    </svg>
  );
}

export default SvgError;
